import { uploadImage, removeImage } from "./uploadImage";
import { uploadMenu, updateMenu, retrieveData, deleteData } from "./uploadMenu";
import { questions as globalQuestions, options, subCategories } from "./databaseQuestions";
import { checkSpecialRequirement } from "../components/CustomForms/QuestionContainer/questionValidator";

export default function validateFormHandler(data, parentFormData = {}, questions = globalQuestions) {
	let filteredData = {};
	const iterableData = Object.entries(data);

	for (const [key, val] of iterableData) {
		const isSubCategory = key === "subCategories";
		const isOption = key === "options";
		const isParent = isSubCategory || isOption;
		const question = questions.find((question) => question.id === key);
		const shouldSkipValueCheck = question && !checkSpecialRequirement(question, { formData: data, parentFormData });
		const isQuestionRequired = question && question.required;
		const isValueEmpty = val === "";

		if (shouldSkipValueCheck) continue;

		if (isQuestionRequired && isValueEmpty) throw new Error("Falta llenar " + question.label);

		if (isParent) {
			let value = [];
			for (const iteration of val) {
				let tempData;
				if (isSubCategory) {
					tempData = validateFormHandler(iteration, data, subCategories);
				} else {
					tempData = validateFormHandler(iteration, data, options);
				}
				value = [...value, tempData];
			}
			filteredData = { ...filteredData, [key]: value };
			continue;
		}

		const isQuestionTypeNumber = question && question.type === "NumberFormat";
		let finalVal = isQuestionTypeNumber ? Number(val) : val;

		if (key === "scheduleCloses" || key === "scheduleOpens") {
			const convertHour = () => {
				const now = new Date();
				const [hours, minutes] = val.split(":");
				now.setHours(hours);
				now.setMinutes(minutes);
				return now;
			};

			const timeValue = typeof val === "string" ? convertHour() : val;

			const date = val.hasOwnProperty("toDate") ? timeValue.toDate() : timeValue;
			const hours = date.getHours();
			const mins = date.getMinutes();
			finalVal = `${hours < 10 ? `0${hours}` : hours}:${mins < 10 ? `0${mins}` : mins}`;
		}
		filteredData = { ...filteredData, [key]: finalVal };
	}

	return filteredData;
}

export async function updateFeedWithImageUrl(payload) {
	const { data, handleProgress, nameDB = "defaultStore" } = payload;
	let filteredData = {};
	const iterableData = Object.entries(data);
	const { category = data?.category } = payload;

	for (const [key, val] of iterableData) {
		const isSubCategory = key === "subCategories";
		const isOption = key === "options";
		const isParent = isSubCategory || isOption;
		if (key === "imgUrl" && val.hasOwnProperty("image")) {
			const { ref, url } = await uploadImage(val.image, `${nameDB}/${category}`, handleProgress);
			filteredData = await { ...filteredData, reference: ref, imgUrl: url };
			continue;
		}
		if (isParent) {
			let value = [];
			for (const iteration of val) {
				let tempData;
				const newPayload = { ...payload, data: iteration, category };
				tempData = await updateFeedWithImageUrl(newPayload);
				value = [...value, tempData];
			}
			filteredData = await { ...filteredData, [key]: value };
			continue;
		}
		filteredData = await { ...filteredData, [key]: val };
	}

	return filteredData;
}

export async function updateInfoTODB({ db, data, docID }) {
	if (docID) {
		await updateMenu(db, data, docID);
	} else {
		await uploadMenu(db, data);
	}
	return "Se actualizó correctamente";
}

export async function getDataFromDB({ db, id }) {
	const data = await retrieveData(db, id);
	return data;
}

async function deleteImagesFromStorage(data) {
	if (data?.reference) {
		await removeImage(data.reference);
	}
	const tempData = data?.subCategories || data?.options;
	if (tempData) {
		for (let item of tempData) {
			await deleteImagesFromStorage(item);
		}
	}
}

export async function deleteFromDB({ db, id, data }) {
	await deleteImagesFromStorage(data);
	await deleteData(db, id);
}
